import Component from "./GenericGame2024";

export default Component;
